import React, { useState, useEffect } from "react";
import { Redirect, NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import keys from "../store/keys";
import { setKey, session } from "../store/actions";
import { connect } from "react-redux";
import "rodal/lib/rodal.css";
import utils from "../utils/utils";
import userService from "../services/user";
import adminService from "../services/admin";
import adService from "../services/ad";
import UserAds from "./UserAds";
import NumberFormat from "react-number-format";
import "../css/user-details.css";
import {
	swalError,
	swalSuccess,
	swalConfirm,
	swalShare,
	swalChangePassword,
	swalDeleteForm
} from "../utils/swal";

function UserDetails({ session, setKey, ...props }) {
	const { t } = useTranslation();
	const [redirectTo, setRedirectTo] = useState(null);
	const [details, setDetails] = useState(null);
	const [publicProfile, setPublicProfile] = useState("#");
	const [counter, setCounter] = useState(1);

	useEffect(() => {
		reload();
	}, []);

	const reload = async () => {
		const userId = props.match.params.userId;
		if (userId) {
			setKey(keys.isLoading, true);
			await userService
				.getDetailsById(session.token, userId)
				.then(result => {
					if (result.error) {
						swalError(result.error);
						setKey(keys.isLoading, false);
						return;
					}

					setKey(keys.isLoading, false);
					setDetails(result.data);

					let url = `${process.env.REACT_APP_APP_URL}/profile/${userId}`;
					setPublicProfile(url);
				});
		}
	};

	const handleDeactivate = e => {
		e.preventDefault();
		const userId = props.match.params.userId;
		if (userId) {
			swalConfirm({
				callback: async () => {
					await userService
						.updateActiveStatus(session.token, userId, false)
						.then(result => {
							if (result.error) {
								swalError(result.error);
								setKey(keys.isLoading, false);
								return;
							}

							setKey(keys.isLoading, false);
							reload();
						});
				}
			});
		}
	};

	const handleActivate = e => {
		e.preventDefault();
		const userId = props.match.params.userId;
		if (userId) {
			swalConfirm({
				callback: async () => {
					await userService
						.updateActiveStatus(session.token, userId, true)
						.then(result => {
							if (result.error) {
								swalError(result.error);
								setKey(keys.isLoading, false);
								return;
							}

							setKey(keys.isLoading, false);
							reload();
						});
				}
			});
		}
	};

	const handleCopyUrl = e => {
		e.preventDefault();
		const userId = props.match.params.userId;
		if (userId) {
			swalShare(`${process.env.REACT_APP_APP_URL}/users/${userId}`);
		}
	};

	const handleChangePassword = e => {
		e.preventDefault();
		const userId = props.match.params.userId;
		if (userId) {
			swalChangePassword(async newPassword => {
				await adminService
					.changeUsersPassword(session.token, { userId, newPassword })
					.then(result => {
						if (result.error) {
							swalError(result.error);
							setKey(keys.isLoading, false);
							return;
						}

						setKey(keys.isLoading, false);
						swalSuccess(t("password_updated"));
					});
			});
		}
	};

	const handleDeleteUserAndAds = e => {
		e.preventDefault();
		const userId = props.match.params.userId;
		if (userId) {
			swalDeleteForm(async () => {
				await userService
					.deleteUserAndAds(session.token, userId)
					.then(result => {
						if (result.error) {
							swalError(result.error);
							setKey(keys.isLoading, false);
							return;
						}

						setKey(keys.isLoading, false);
						swalSuccess(
							t("user_ads_deleted")
						);
						window.location.href = `/users`;
					});
			});
		}
	};

	const handleActivateAllAds = e => {
		e.preventDefault();
		const userId = props.match.params.userId;
		if (userId) {
			swalConfirm({
				callback: async () => {
					await adService
						.updateActiveStatusAllUserAds(
							session.token,
							userId,
							true
						)
						.then(result => {
							if (result.error) {
								swalError(result.error);
								setKey(keys.isLoading, false);
								return;
							}

							setKey(keys.isLoading, false);
							setCounter(counter + 1);
						});
				}
			});
		}
	};

	const handleDeactivateAllAds = e => {
		e.preventDefault();
		const userId = props.match.params.userId;
		if (userId) {
			swalConfirm({
				callback: async () => {
					await adService
						.updateActiveStatusAllUserAds(
							session.token,
							userId,
							false
						)
						.then(result => {
							if (result.error) {
								swalError(result.error);
								setKey(keys.isLoading, false);
								return;
							}

							setKey(keys.isLoading, false);
							setCounter(counter + 1);
						});
				}
			});
		}
	};

	const handleSoldStatusAllAds = e => {
		e.preventDefault();
		const userId = props.match.params.userId;
		if (userId) {
			swalConfirm({
				callback: async () => {
					await adService
						.updateSoldStatusAllUserAds(session.token, userId, true)
						.then(result => {
							if (result.error) {
								swalError(result.error);
								setKey(keys.isLoading, false);
								return;
							}

							setKey(keys.isLoading, false);
							setCounter(counter + 1);
						});
				}
			});
		}
	};

	const handleAvailableStatusAllAds = e => {
		e.preventDefault();
		const userId = props.match.params.userId;
		if (userId) {
			swalConfirm({
				callback: async () => {
					await adService
						.updateSoldStatusAllUserAds(
							session.token,
							userId,
							false
						)
						.then(result => {
							if (result.error) {
								swalError(result.error);
								setKey(keys.isLoading, false);
								return;
							}

							setKey(keys.isLoading, false);
							setCounter(counter + 1);
						});
				}
			});
		}
	};

	const handleDeleteAllAds = e => {
		e.preventDefault();
		const userId = props.match.params.userId;
		if (userId) {
			swalDeleteForm(async () => {
				await adService
					.deleteAllAds(session.token, userId)
					.then(result => {
						if (result.error) {
							swalError(result.error);
							setKey(keys.isLoading, false);
							return;
						}

						setKey(keys.isLoading, false);
						setCounter(counter + 1);
					});
			});
		}
	};

	return (
		<div className="container user-details-page">
			{redirectTo && <Redirect push to={redirectTo} />}
			{details && (
				<div className="row">
					{/* LEFT COLUMN: Profile & Contact */}
					<div className="col-lg-4 mb-4">
						<div className="ud-card text-center">
							<img
								className="ud-avatar"
								src={`${details.user.fileUrl}`}
								alt={details.user.name}
							/>
							<h2 className="ud-name">{details.user.name}</h2>

							<div className="mb-3">
								{details.user.active === true ? (
									<span className="ud-badge-active mr-2">
										{t("account_active")}
									</span>
								) : (
									<span className="ud-badge-inactive mr-2">
										{t("account_inactive")}
									</span>
								)}
								{details.user.accountType === 'official' && (
									<span className="badge badge-primary px-2 py-1">{t("official_store")}</span>
								)}
							</div>

							<p className="ud-bio">
								{details.user.bio || t("no_bio")}
							</p>
						</div>

						<div className="ud-card">
							<h5 className="ud-section-title">
								<i className="fa fa-address-card"></i> {t("contact_info")}
							</h5>
							<div className="ud-info-list">
								<div className="ud-info-row">
									<div className="ud-info-icon">
										<i className="fa fa-envelope"></i>
									</div>
									<div className="text-break">{details.user.email}</div>
								</div>
								<div className="ud-info-row">
									<div className="ud-info-icon">
										<i className="fa fa-phone"></i>
									</div>
									<div>{details.user.phone}</div>
								</div>
								<div className="ud-info-row">
									<div className="ud-info-icon">
										<i className="fa fa-map-marker-alt"></i>
									</div>
									<div>
										{(details.user.cityId &&
											details.user.cityId.title) ||
											t("na")}
										, {details.user.country}
									</div>
								</div>
								<div className="ud-info-row">
									<div className="ud-info-icon">
										<i className="fa fa-clock"></i>
									</div>
									<div>
										{t("joined_label")}: {utils.monthYearFormat(details.user.joined)}
									</div>
								</div>
								<div className="ud-info-row">
									<div className="ud-info-icon">
										<i className="fa fa-globe"></i>
									</div>
									<div>{t("label_ip")}: {details.user.ip}</div>
								</div>
							</div>
						</div>

						{details.user.accountType && details.user.accountType.toLowerCase() === 'business' && (
							<div className="ud-card mt-4">
								<h5 className="ud-section-title">
									<i className="fa fa-briefcase"></i> {t("business_info")}
								</h5>
								<div className="ud-info-list">
									<div className="ud-info-row">
										<div className="ud-info-icon">
											<i className="fa fa-building"></i>
										</div>
										<div>
											<small className="text-muted d-block">{t("business_name")}</small>
											{details.user.businessName || t("na")}
										</div>
									</div>
									<div className="ud-info-row">
										<div className="ud-info-icon">
											<i className="fa fa-map-marked-alt"></i>
										</div>
										<div>
											<small className="text-muted d-block">{t("business_address")}</small>
											{details.user.businessAddress || t("na")}
										</div>
									</div>
									<div className="ud-info-row">
										<div className="ud-info-icon">
											<i className="fa fa-phone-square"></i>
										</div>
										<div>
											<small className="text-muted d-block">{t("business_phone")}</small>
											{details.user.businessPhone || t("na")}
										</div>
									</div>
								</div>
							</div>
						)}
					</div>

					{/* RIGHT COLUMN: Actions & Tabs */}
					<div className="col-lg-8">
						{/* ACTIONS CARD */}
						<div className="ud-card mb-4">
							<h5 className="ud-section-title">
								<i className="fa fa-cogs"></i> {t("actions_label")}
							</h5>
							<div className="row">
								<div className="col-md-6">
									<span className="ud-sub-header">{t("user_management_label")}</span>
									{details.user.active === false && (
										<button
											className="ud-action-btn ud-btn-success"
											onClick={handleActivate}
										>
											<i className="fa fa-check"></i> {t("activate_user")}
										</button>
									)}
									{details.user.active === true && (
										<button
											className="ud-action-btn ud-btn-secondary"
											onClick={handleDeactivate}
										>
											<i className="fa fa-ban"></i> {t("deactivate_user")}
										</button>
									)}
									<button
										className="ud-action-btn ud-btn-primary"
										onClick={handleChangePassword}
									>
										<i className="fa fa-key"></i> {t("change_password")}
									</button>

									<a
										className="ud-action-btn ud-btn-secondary"
										target="_blank"
										href={`${publicProfile}`}
										rel="noopener noreferrer"
										style={{ textDecoration: 'none' }}
									>
										<i className="fa fa-external-link-alt"></i> {t("view_public_profile")}
									</a>

									<div className="mt-3">
										<span className="ud-sub-header">{t("account_type")}</span>
										<select
											className="form-control"
											value={details.user.accountType || 'personal'}
											onChange={(e) => {
												const newType = e.target.value;
												swalConfirm({
													title: t("change_to_confirm", { type: newType }),
													callback: async () => {
														await adminService.changeAccountType(session.token, details.user._id, newType)
															.then(result => {
																if (result.error) {
																	swalError(result.error);
																	return;
																}
																setKey(keys.isLoading, false);
																reload();
																swalSuccess(t("account_type_updated"));
															});
													}
												});
											}}
										>
											<option value="personal">{t("account_personal")}</option>
											<option value="business">{t("account_business")}</option>
											<option value="official">{t("account_official")}</option>
										</select>
									</div>

									<button
										className="ud-action-btn ud-btn-secondary mt-3"
										onClick={handleCopyUrl}
									>
										<i className="fa fa-copy"></i> {t("copy_profile_url")}
									</button>

									<button
										className="ud-action-btn ud-btn-danger mt-2"
										onClick={handleDeleteUserAndAds}
									>
										<i className="fa fa-trash"></i> {t("delete_user_ads")}
									</button>

									<hr className="my-3" />
									<span className="ud-sub-header">{t("reputation_badges")}</span>
									<div className="card-modern p-3 bg-light">
										<div className="form-group mb-2">
											<label className="small font-weight-bold">{t("trust_score")}</label>
											<input
												type="number"
												className="form-control form-control-sm"
												value={details.user.reputation?.trustScore || 0}
												onChange={async (e) => {
													const newScore = parseInt(e.target.value);
													const user = { ...details.user };
													user.reputation = { ...user.reputation, trustScore: newScore };
													await adminService.updateUserReputation(session.token, user._id, user.reputation);
													reload();
												}}
											/>
										</div>
										<div className="d-flex flex-wrap">
											{['verified', 'pro_seller', 'early_adopter', 'top_rated'].map(badge => (
												<div key={badge} className="custom-control custom-checkbox mr-3">
													<input
														type="checkbox"
														className="custom-control-input"
														id={`badge-${badge}`}
														checked={details.user.reputation?.badges?.includes(badge)}
														onChange={async (e) => {
															let badges = details.user.reputation?.badges || [];
															if (e.target.checked) {
																if (!badges.includes(badge)) badges.push(badge);
															} else {
																badges = badges.filter(b => b !== badge);
															}
															const reputation = { ...details.user.reputation, badges };
															await adminService.updateUserReputation(session.token, details.user._id, reputation);
															reload();
														}}
													/>
													<label className="custom-control-label small" htmlFor={`badge-${badge}`}>{badge.replace('_', ' ')}</label>
												</div>
											))}
										</div>
									</div>
								</div>

								<div className="col-md-6 border-left-md">
									<span className="ud-sub-header">{t("bulk_ad_actions")}</span>
									<button
										className="ud-action-btn ud-btn-success"
										onClick={handleActivateAllAds}
									>
										<i className="fa fa-check-double"></i> {t("activate_all_ads")}
									</button>
									<button
										className="ud-action-btn ud-btn-secondary"
										onClick={handleDeactivateAllAds}
									>
										<i className="fa fa-ban"></i> {t("deactivate_all_ads")}
									</button>
									<button
										className="ud-action-btn ud-btn-secondary"
										onClick={handleAvailableStatusAllAds}
									>
										<i className="fa fa-tag"></i> {t("mark_all_available")}
									</button>
									<button
										className="ud-action-btn ud-btn-secondary"
										onClick={handleSoldStatusAllAds}
									>
										<i className="fa fa-handshake"></i> {t("mark_all_sold")}
									</button>
									<button
										className="ud-action-btn ud-btn-danger mt-2"
										onClick={handleDeleteAllAds}
									>
										<i className="fa fa-trash-alt"></i> {t("delete_all_ads")}
									</button>
								</div>
							</div>
						</div>

						{/* TABS CARD */}
						<div className="ud-card p-0 overflow-hidden">
							<ul className="nav nav-tabs ud-tabs" role="tablist">
								<li className="nav-item">
									<a
										className="nav-link active"
										id="ads-tab"
										data-toggle="tab"
										href="#ads"
										role="tab"
										aria-controls="ads"
										aria-selected="true"
									>
										<i className="fa fa-ad mr-2"></i> {t("user_ads_tab")}
									</a>
								</li>
								<li className="nav-item">
									<a
										className="nav-link"
										id="reports-tab"
										data-toggle="tab"
										href="#reports"
										role="tab"
										aria-controls="reports"
										aria-selected="false"
									>
										<i className="fa fa-flag mr-2"></i> {t("reports_tab")}
									</a>
								</li>
								<li className="nav-item">
									<a
										className="nav-link"
										id="reports-against-tab"
										data-toggle="tab"
										href="#reports-against"
										role="tab"
										aria-controls="reports-against"
										aria-selected="false"
									>
										<i className="fa fa-exclamation-triangle mr-2"></i> {t("reports_against")}
									</a>
								</li>
							</ul>
							<div className="tab-content p-4">
								<div
									className="tab-pane fade show active"
									id="ads"
									role="tabpanel"
									aria-labelledby="ads-tab"
								>
									<UserAds
										userId={details.user._id}
										counter={counter}
									/>
								</div>
								<div
									className="tab-pane fade"
									id="reports"
									role="tabpanel"
									aria-labelledby="reports-tab"
								>
									<div className="text-center p-5 text-muted">
										<i className="fa fa-tools fa-3x mb-3"></i>
										<p>{t("coming_soon")}</p>
									</div>
								</div>
								<div
									className="tab-pane fade"
									id="reports-against"
									role="tabpanel"
									aria-labelledby="reports-against-tab"
								>
									<div className="text-center p-5 text-muted">
										<i className="fa fa-tools fa-3x mb-3"></i>
										<p>{t("coming_soon")}</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			)}
		</div>
	);
}

const mapStateToProps = store => ({
	session: store.session
});

const mapDispatchToProps = dispatch => ({
	setKey: (key, value) => dispatch(setKey(key, value))
});

export default connect(mapStateToProps, mapDispatchToProps)(UserDetails);
